<template>
  <div class="row">
    <div class="col">
      <div
        class="card"
        style="background-color: #00a3e9; color: white; overflow: hidden"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div style="padding: 15px">
            <div class="d-flex align-items-center">
              <div class="me-2">
                <img class="" src="@/assets/images/logo/Rounded.svg" />
              </div>
              <div>
                <span style="font-size: 14px; font-weight: 600;">{{title}}</span>
              </div>
            </div>
            <div style="margin-left: 36px">
              <ul class="header_page_list" v-for="(item, index) in list" :key="index">
                <li style="font-size: 14px;">{{item}}</li>
              </ul>
            </div>
          </div>
          <div>
            <img
              :src="image"
              :style="'mix-blend-mode:'+tipe_gambar"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: ["title", "list", "image", "tipe_gambar"],
  props: {
    title: String,
    list: Array,
    tipe_gambar: String,
    image: String,
  },
  mounted() {
  },
};
</script>